exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.time-success[data-v-f816346e] {\n  color: #1DC763\n}\n.time-info[data-v-f816346e] {\n  color: #92959A\n}\n", ""]);

// exports
